var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDapperOnTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78.097984mm",
    height: "72.743408mm",
    viewBox: "0 0 78.097982 72.743406",
    id: "svg692",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs689"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-67.017392,-105.70076)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g386",
    transform: "matrix(0.26458333,0,0,0.26458333,-30.299002,99.283484)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 367.81,
    y1: 201.53999,
    x2: 651.28003,
    y2: 201.03,
    id: "line382"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 509.54001,
    y1: 157.37,
    x2: 509.54001,
    y2: 245.2,
    id: "line384"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 136.72981,138.77256 c -1.50283,0.76464 -2.159,2.11137 -2.37596,2.57174 -1.44198,3.06917 0.78052,5.00592 0.57944,9.5303 -0.0688,1.50548 -0.22225,4.95035 -2.48973,6.985 -1.87325,1.6801 -4.49262,1.7727 -9.05933,1.93675 -3.6195,0.12964 -5.86052,-0.31486 -7.60677,1.31498 -0.33073,0.30956 -1.21444,1.13241 -1.10596,2.07433 0.26987,2.33098 6.39233,3.27554 7.12258,3.38931 1.6854,0.25929 7.73642,1.11919 13.90121,-2.42094 1.52135,-0.87312 4.06135,-2.37066 6.01662,-5.39485 1.73038,-2.67229 2.16959,-5.25463 2.48973,-7.12258 0.2884,-1.6854 0.62707,-3.78884 0.13759,-6.43202 -0.37836,-2.04523 -1.05305,-5.6859 -3.73327,-6.70719 -1.86796,-0.71438 -3.74121,0.20637 -3.87615,0.27517 z",
    id: "path418",
    style: {
      fill: "#b886d1",
      fillOpacity: 1,
      stroke: "#1e1e1c",
      strokeWidth: 1.05833,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 130.63646,121.89743 c -0.44715,-0.26194 -0.99484,-0.11113 -2.97392,0.762 -3.83117,1.68539 -4.36563,2.25954 -6.36323,3.1115 -1.80975,0.77258 -4.20687,1.79652 -7.11465,1.95262 -4.04812,-2.13519 -8.7577,-3.36021 -13.78214,-3.36021 -5.024441,0 -9.731378,1.22502 -13.782149,3.36021 -2.910416,-0.15875 -5.307541,-1.18004 -7.114645,-1.95262 -1.997604,-0.85461 -2.532063,-1.42611 -6.363229,-3.1115 -1.979084,-0.87048 -2.526771,-1.0213 -2.973917,-0.762 -0.619125,0.35983 -1.17475,1.5822 0.690563,9.47472 1.314979,5.56155 2.098145,8.78682 3.386666,10.36374 -0.812271,2.34421 -1.248833,4.83658 -1.248833,7.42156 0,13.69219 12.268729,24.7941 27.402894,24.7941 15.13417,0 27.4029,-11.09927 27.4029,-24.7941 0,-2.58498 -0.43921,-5.07735 -1.24883,-7.42156 1.28852,-1.57692 2.07433,-4.80219 3.38666,-10.36374 1.87061,-7.89252 1.31763,-9.11489 0.69586,-9.47472 z",
    id: "path420",
    style: {
      fill: "#b886d1",
      fillOpacity: 1,
      stroke: "#1e1e1c",
      strokeWidth: 1.05833,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 121.13527,146.5857 c 0.3175,0.61913 0.6985,1.57163 0.74348,2.74902 0.0476,1.27529 -0.32544,2.08492 -0.65617,3.09563 -0.0529,0.1561 -1.19856,3.73856 -0.79639,7.34748 0.10318,0.92339 0.77258,2.51883 1.45785,4.10633",
    id: "path422",
    style: {
      fill: "none",
      stroke: "#1e1e1c",
      strokeWidth: 1.32292,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 87.091331,
    cy: 144.46902,
    r: 3.061229,
    id: "circle424",
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 111.92777,
    cy: 144.46902,
    r: 3.061229,
    id: "circle426",
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 113.14221,
    cy: 144.68333,
    r: 6.3632288,
    id: "circle428",
    style: {
      fill: "none",
      stroke: "#1e1e1c",
      strokeWidth: 1.32292,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 120.36533,
    cy: 146.1015,
    rx: 1.3229166,
    ry: 0.89958334,
    id: "ellipse430",
    style: {
      fill: "#ffcc03",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 100.27287,
    cy: 158.6216,
    rx: 1.9499791,
    ry: 0.5715,
    id: "ellipse432",
    style: {
      fill: "#d99cc6",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m 100.27287,148.09383 h 0.70909 c 1.61131,0 2.61673,1.47108 1.81239,2.64847 l -0.35454,0.51859 -0.35454,0.51858 c -0.80433,1.1774 -2.820462,1.1774 -3.624795,0 l -0.354542,-0.51858 -0.354541,-0.51859 c -0.804334,-1.17739 0.201083,-2.64847 1.812396,-2.64847 z",
    id: "path434",
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g440",
    transform: "matrix(0.26458333,0,0,0.26458333,-30.299002,99.283484)",
    style: {
      fill: "#1e1e1c",
      fillOpacity: 1,
      stroke: "#1e1e1c",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m 491.6,216.6 c 0.49,0.36 2.45,1.83 2.53,3.94 0.05,1.19 -0.5,2.76 -3.38,5.07 -5.18,4.16 -11.08,5.26 -12.39,5.49 -11,1.93 -18.64,-1.1 -31.82,-6.34 -1.02,-0.41 -3.14,-1.28 -4.22,-3.38 -0.09,-0.17 -1.62,-3.26 0.14,-5.77 1.22,-1.74 3.65,-2.7 5.35,-1.97 0.97,0.42 1.75,1.4 1.55,1.83 -0.23,0.51 -1.65,-0.17 -2.82,0.56 -0.97,0.61 -1.6,2.11 -1.27,2.96 0.22,0.55 1.31,2.03 13.66,0.42 5.13,-0.67 8.38,-1.37 17.04,-2.96 8.58,-1.56 12.51,-2.18 15.63,0.15 z",
    id: "path436",
    style: {
      fill: "#1e1e1c",
      fillOpacity: 1,
      stroke: "#1e1e1c",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m 495.41,216.6 c -0.49,0.36 -2.45,1.83 -2.53,3.94 -0.05,1.19 0.5,2.76 3.38,5.07 5.18,4.16 11.08,5.26 12.39,5.49 11,1.93 18.64,-1.1 31.82,-6.34 1.02,-0.41 3.14,-1.28 4.22,-3.38 0.09,-0.17 1.62,-3.26 -0.14,-5.77 -1.22,-1.74 -3.65,-2.7 -5.35,-1.97 -0.97,0.42 -1.75,1.4 -1.55,1.83 0.23,0.51 1.65,-0.17 2.82,0.56 0.97,0.61 1.6,2.11 1.27,2.96 -0.22,0.55 -1.31,2.03 -13.66,0.42 -5.13,-0.67 -8.38,-1.37 -17.04,-2.96 -8.59,-1.56 -12.52,-2.18 -15.63,0.15 z",
    id: "path438",
    style: {
      fill: "#1e1e1c",
      fillOpacity: 1,
      stroke: "#1e1e1c",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g458",
    transform: "matrix(0.26458333,0,0,0.26458333,-30.299002,99.283484)",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g448",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 403.99,148.61 c 1.74,-5.14 5,-12.72 11.24,-20.39 4.75,-5.83 9.72,-9.87 13.59,-12.55",
    id: "path442",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 404.51,109.14 c 0.04,1.52 0.36,5.08 2.88,8.36 4.73,6.18 11.5,5.96 12.17,5.91",
    id: "path444",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 397.19,120.29 c 1.42,1.4 4.04,3.61 7.93,4.97 6.09,2.11 10.26,1.09 12.2,0.49",
    id: "path446",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g456",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 586.69,150.95 c -1.74,-5.14 -5,-12.72 -11.24,-20.39 -4.75,-5.83 -9.72,-9.87 -13.59,-12.55",
    id: "path450",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 586.17,111.48 c -0.04,1.52 -0.36,5.08 -2.88,8.36 -4.73,6.18 -11.5,5.96 -12.17,5.91",
    id: "path452",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 593.49,122.64 c -1.42,1.4 -4.04,3.61 -7.93,4.97 -6.09,2.11 -10.26,1.09 -12.2,0.49",
    id: "path454",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M 78.256892,132.93055",
    id: "path460",
    style: {
      fill: "none",
      stroke: "#1e1e1c",
      strokeWidth: 1.32292,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g478",
    transform: "matrix(0.26458333,0,0,0.26458333,-30.299002,99.283484)",
    style: {
      opacity: 1,
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g468",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 455.37,
    cy: 282.20001,
    rx: 34.189999,
    ry: 16.99,
    id: "ellipse462",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m 442.68,286.91 c 0.36,0.79 1.05,2.6 0.7,4.88 -0.21,1.36 -0.72,2.39 -1.05,2.96 -0.67,1.16 -1.47,1.92 -2,2.35",
    id: "path464",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m 465.99,286.91 c -0.36,0.79 -1.05,2.6 -0.7,4.88 0.21,1.36 0.72,2.39 1.05,2.96 0.67,1.16 1.47,1.92 2,2.35",
    id: "path466",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g476",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 528.32001,
    cy: 282.20001,
    rx: 34.189999,
    ry: 16.99,
    id: "ellipse470",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m 515.63,286.91 c 0.36,0.79 1.05,2.6 0.7,4.88 -0.21,1.36 -0.72,2.39 -1.05,2.96 -0.67,1.16 -1.47,1.92 -2,2.35",
    id: "path472",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m 538.95,286.91 c -0.36,0.79 -1.05,2.6 -0.7,4.88 0.21,1.36 0.72,2.39 1.05,2.96 0.67,1.16 1.47,1.92 2,2.35",
    id: "path474",
    style: {
      stroke: "#1e1e1c",
      strokeOpacity: 1,
      fill: "#1e1e1c",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m 114.52862,126.68109 5.15673,-15.6501 c 0.14552,-0.70115 -0.37041,-1.40494 -1.143,-1.56633 l -17.92817,-3.73063 c -0.775226,-0.1614 -1.529288,0.28046 -1.674809,0.97896 l -1.516063,16.40681 c -3.349625,-0.34925 -5.572124,-0.26723 -5.693833,0.3175 -0.209021,1.00806 5.865813,3.12208 13.567835,4.72546 7.70202,1.60337 14.11817,2.08492 14.32719,1.0795 0.11906,-0.58473 -1.88384,-1.54517 -5.09588,-2.56117 z",
    id: "path480",
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0.264583
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDapperOnTransparent);
export default __webpack_public_path__ + "static/media/DapperOnTransparent.a31ef4eda730abb406087ad95eb395a0.svg";
export { ForwardRef as ReactComponent };